import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import ProjectDetailSF from '../../../components/superUser/loan/ProjectDetailSF'
import ProjectCreateModalSF from '../../../components/superUser/loan/ProjectCreateModalSF'
import ProjectUpdateModalSF from '../../../components/superUser/loan/ProjectUpdateModalSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ProjectsNavUI from '../../../components/superUser/loan/ProjectsNavUI.js';

const ProjectDetailPageUI = ({ context, errorList, loan, onRefreshClick,
  customerList, filteredCustomerList, selectedCustomer, createProjectMode,
  onCreateProjectClick, onCancelCreateProject,
  updateProjectMode, onProjectUpdateClick, onProjectUpdateCancel, selectedProject
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='projects' dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <ProjectDetailSF context={context} loan={loan}
        onRefreshClick={onRefreshClick}
        customerList={customerList}
        filteredCustomerList={filteredCustomerList}
        selectedCustomer={selectedCustomer}
        createProjectMode={createProjectMode}
        onCreateProjectClick={onCreateProjectClick}
        onCancelProjectClick={onCancelCreateProject}
        updateProjectMode={updateProjectMode}
        onProjectUpdateClick={onProjectUpdateClick}
        onProjectUpdateCancel={onProjectUpdateCancel}
      />
    }

    <ProjectCreateModalSF context={context}
      loan={loan} onRefreshClick={onRefreshClick} customerList={filteredCustomerList}
      createMode={createProjectMode} onCancelCreate={onCancelCreateProject}
    />
    {
      loan && loan.termSheet.project &&
      <ProjectUpdateModalSF context={context}
        loan={loan} selectedProject={selectedProject} onRefreshClick={onRefreshClick} customerList={filteredCustomerList}
        updateMode={updateProjectMode} onCancelUpdate={onProjectUpdateCancel}
      />
    }
  </SuperUserLoanPageUI>

export default ProjectDetailPageUI
